import PropTypes from 'prop-types';
import { createContext, useEffect, useReducer, useState } from 'react';

// third-party
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import { getDatabase, ref, set, get, child, update } from 'firebase/database';
import 'firebase/compat/app-check';
// project imports
import Loader from 'ui-component/Loader';

//redux
import { useDispatch, useSelector } from 'react-redux';
//action redux
import { loginUser, logoutUser, registerUser } from 'store/slices/account';
// import { addProjects } from 'store/slices/project';
import {
    FIREBASE_USER_UPDATE,
    FETCH_BILLING,
    FETCH_PROJECT
} from 'store/actions';
import accountReducer from 'store/accountReducer';
// import { openSnackbar } from 'store/slices/snackbar';
// import { getBillings } from 'store/slices/user';
import apiSlice from 'store/slices/apiSlice';
import { useNavigate } from 'react-router-dom';
import { authManager } from 'utils/authManager';
// Removed AWS S3 usage; switching to Firebase Storage exclusively

// firebase initialize

if (!firebase.apps.length) {
    firebase.initializeApp({
        apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
        authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
        projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
        databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
        storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
        appId: process.env.REACT_APP_FIREBASE_APP_ID,
        measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
    });
}

// const

const setSession = (serviceToken) => {
    if (serviceToken) {
        localStorage.setItem('serviceToken', serviceToken);
    } else {
        localStorage.removeItem('serviceToken');
    }
};

const initialState = {
    isLoggedIn: false,
    isLoadingProduct: true,
    isProfile: false,
    isInitialized: false,
    dataProductDetails: [],
    dataProductImages: [],
    user: null,
    billings: [],
    queries: [],
    status: 'idle',
    conversationId: null
};
const db = getDatabase();
// Enable App Check with real site key
firebase.appCheck().activate(new firebase.appCheck.ReCaptchaEnterpriseProvider(process.env.REACT_APP_FIREBASE_APP_CHECK_SITE_KEY), true);

// ==============================|| FIREBASE CONTEXT & PROVIDER ||============================== //

const FirebaseContext = createContext(null);

export const FirebaseProvider = ({ children }) => {
    const [state, dispatch] = useReducer(accountReducer, initialState); //useReducer

    const Rdispatch = useDispatch(); //redux
    const account = useSelector((state) => state.account);

    const navigate = useNavigate();
    const features = [
        'chatgpt',
        'document',
        'mindmap',
        'slide',
        'assignment',
        'translate',
        'report',
        'plan',
        'research',
        'publish',
        'task',
        'revise',
        'blog'
    ];

    const [password, setPassword] = useState('');
    const [length, setLength] = useState(12);
    const [includeNumbers, setIncludeNumbers] = useState(true);
    const [includeSymbols, setIncludeSymbols] = useState(true);

    const generatePassword = (user_token) => {
        let chars = user_token;
        let generatedPassword = '';
        for (let i = 0; i < chars.length / 2; i++) {
            generatedPassword += chars[i + 3];
        }
        return generatedPassword;
    };

    // useEffect(() => {
    //     generatePassword()
    // },[])

    useEffect(
        () => {
            if (authManager.getToken()) {
                return;
            }

            // Token refresh interval (50 minutes)
            let tokenRefreshInterval = null;

            const refreshToken = async (user) => {
                try {
                    const idToken = await user.getIdToken(true);
                    authManager.setToken(idToken, 'firebase_token');
                } catch (error) {
                    console.error('❌ Error refreshing Firebase ID token:', error);
                }
            };

            return firebase.auth().onAuthStateChanged(async (user) => {

                if (user) {
                    // Store Firebase UID for user identification
                    localStorage.setItem('user_token', user['_delegate']['uid']);

                    // Get and store Firebase ID token for API authentication
                    try {
                        const idToken = await user.getIdToken();
                        authManager.setToken(idToken, 'firebase_token');
                    } catch (error) {
                        console.error('❌ Error getting Firebase ID token:', error);
                    }

                    // Setup token refresh every 50 minutes (tokens expire after 1 hour)
                    if (tokenRefreshInterval) {
                        clearInterval(tokenRefreshInterval);
                    }
                    tokenRefreshInterval = setInterval(() => refreshToken(user), 50 * 60 * 1000);

                    // console.log(user['_delegate']['uid']);
                    const password = generatePassword(user['_delegate']['uid']);
                    const dbRef = ref(db);
                    get(child(dbRef, 'users/' + user['_delegate']['uid'])).then(async (snapshot) => {
                        if (snapshot.exists()) {
                            if (user.emailVerified) {
                                localStorage.setItem('user_email', snapshot.val()['email']);
                                set(ref(db, 'users/' + user['_delegate']['uid']), {
                                    email: snapshot.val()['email'],
                                    email_verified: user.emailVerified,
                                    displayName: snapshot.val()['displayName'],
                                    user_type: snapshot.val()['user_type'],
                                    mongodb_passwd: password,
                                    phone_number: snapshot.val()['phone_number'],
                                    photo_url: snapshot.val()['photo_url'],
                                    business_name: snapshot.val()['business_name'],
                                    education_or_enterprise: snapshot.val()['education_or_enterprise'],
                                    token_usage: snapshot.val()['token_usage'],
                                    storage_usage_mb: snapshot.val()['storage_usage_mb'],
                                    is_profile: snapshot.val()['is_profile'],
                                    is_status: snapshot.val()['is_status'],
                                    provider: snapshot.val()['provider'],
                                    created_date: user['_delegate']['metadata']['createdAt'],
                                    created_time: user['_delegate']['metadata']['creationTime'],
                                    last_login_date: user['_delegate']['metadata']['lastLoginAt'],
                                    last_login_time: user['_delegate']['metadata']['lastSignInTime']
                                });

                                // Removed S3 folder provisioning; migration to Firebase Storage

                                localStorage.setItem('user_type', snapshot.val()['user_type']);
                                const formData = new FormData();
                                formData.append('user_token', user['_delegate']['uid']);
                                formData.append('user_type', snapshot.val()['user_type']);
                                const response = await Rdispatch(apiSlice.endpoints.postBillingUsage.initiate(formData)).unwrap();
                                dispatch({
                                    type: FETCH_BILLING,
                                    payload: { billings: response }
                                });

                                // const formData2 = new FormData();
                                // formData2.append('user_token', user['_delegate']['uid'])
                                // formData2.append('project_name', 'Default')
                                // formData2.append('description', 'Default Project')
                                // formData2.append('mongodb_passwd', password)
                                // const response2 = await axios2.post('/projects/', formData2,{
                                //     headers: {
                                //         //         //         //         'Content-Type': 'multipart/form-data'
                                //     },
                                // });

                                // dispatch({
                                //     type: FETCH_PROJECT,
                                //     payload: {
                                //         projects: response2.data
                                //     }
                                // });

                                // const formData3 = new FormData();
                                // formData3.append('user_token', user['_delegate']['uid'])
                                // formData3.append('mongodb_passwd', snapshot.val()['mongodb_passwd'])
                                // await axios2.post('/users/mongodb/create/', formData3,{
                                //     headers: {
                                //         //         //         //         'Content-Type': 'multipart/form-data'
                                //     },
                                // });

                                Rdispatch(
                                    loginUser({
                                        user: snapshot.val()
                                    })
                                );

                                // dispatch(getBillings(user['_delegate']['uid']));

                                // if(snapshot.val()['is_profile'] === true){
                                //     navigate('/workspace/document', { replace: true })
                                // } else{
                                //     navigate('/user/account-profile/profile3', { replace: true })
                                // }
                            }
                        } else {
                            set(ref(db, 'users/' + user['_delegate']['uid']), {
                                email: user['_delegate']['email'],
                                email_verified: user.emailVerified,
                                displayName: user['_delegate']['displayName'],
                                user_type: 'trial',
                                mongodb_passwd: password,
                                phone_number: user['_delegate']['phoneNumber'] || '',
                                photo_url: user['_delegate']['photoURL'] || '',
                                business_name: '',
                                education_or_enterprise: '',
                                is_profile: false,
                                is_status: true,
                                token_usage: 0,
                                storage_usage_mb: 0,
                                provider: user['_delegate']['providerData'][0]['providerId'],
                                created_date: user['_delegate']['metadata']['createdAt'],
                                created_time: user['_delegate']['metadata']['creationTime'],
                                last_login_date: user['_delegate']['metadata']['lastLoginAt'],
                                last_login_time: user['_delegate']['metadata']['lastSignInTime']
                            });

                            // Removed S3 root folder creation; using Firebase Storage

                            // Removed S3 list calls

                            // const formData = new FormData();
                            // formData.append('user_token', user['_delegate']['uid']);
                            // formData.append('user_type', 'trial');
                            // const response = await axios2.post('/billings', {
                            //     headers: {
                            //         //         //         //     }
                            // }, formData);
                            // dispatch({
                            //     type: FETCH_BILLING,
                            //     payload: {
                            //         billings: response.data
                            //     }
                            // });

                            const response2 = await Rdispatch(
                                apiSlice.endpoints.createProject.initiate({
                                    project_name: 'Default',
                                    description: 'Default Project'
                                })
                            ).unwrap();

                            dispatch({
                                type: FETCH_PROJECT,
                                payload: { projects: Array.isArray(response2) ? response2 : (response2?.project ? [response2.project] : response2) }
                            });

                            // const formData3 = new FormData();
                            //     formData3.append('user_token', user['_delegate']['uid'])
                            //     formData3.append('mongodb_passwd', password)
                            //     await axios2.post('/users/mongodb/create/', formData3,{
                            //         headers: {
                            //             //             //             //             'Content-Type': 'multipart/form-data'
                            //         },
                            //     });

                            Rdispatch(
                                registerUser({
                                    user: snapshot.val()
                                })
                            );
                        }
                    });
                } else {
                    // Clear token refresh interval on logout
                    if (tokenRefreshInterval) {
                        clearInterval(tokenRefreshInterval);
                        tokenRefreshInterval = null;
                    }

                    authManager.clearTokens();

                    // dispatch({
                    //     type: LOGOUT
                    // });
                    console.log('🔴 FirebaseContext: No Firebase user, logging out');
                    Rdispatch(logoutUser());
                }
            });
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [dispatch, Rdispatch]
    );

    const firebaseEmailPasswordSignIn = async (email, password) => {
        try {
            const userCredential = await firebase.auth().signInWithEmailAndPassword(email, password);
            const user = userCredential.user;
            if (!user.emailVerified) {
                throw new Error('Địa chỉ email chưa được xác thực. Vui lòng kiểm tra lại email xác thực trong địa chỉ email của bạn.');
            } else {
                Rdispatch(
                    registerUser({
                        user: user
                    })
                );
            }
            return user;
        } catch (error) {
            throw error;
        }
    };

    const firebaseGoogleSignIn = () => {
        const provider = new firebase.auth.GoogleAuthProvider();

        return firebase
            .auth()
            .signInWithPopup(provider)
            .then((result) => {
                const credential = result.credential;
                const accessToken = credential.accessToken;
                const idToken = credential.idToken;
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const firebaseMicrosoftSignIn = () => {
        const provider = new firebase.auth.OAuthProvider('microsoft.com');
        navigate('/workspace/storage', { replace: true });
        return firebase.auth().signInWithPopup(provider);
    };

    const firebaseFacebookSignIn = () => {
        const provider = new firebase.auth.OAuthProvider('facebook.com');

        return firebase.auth().signInWithPopup(provider);
    };

    const firebaseRegister = async (email, password, full_name, phone_number) => {
        try {
            // create user in Authentication
            const auth = firebase.auth();
            const userCredential = await auth.createUserWithEmailAndPassword(email, password);
            await auth.currentUser.sendEmailVerification();

            const user = userCredential.user;
            // set Phone number and Full name in realtime database
            await set(ref(db, 'users/' + user.uid), {
                email: user.email,
                email_verified: user.emailVerified,
                displayName: full_name,
                user_type: 'trial',
                phone_number: phone_number,
                photo_url: user['_delegate']['photoURL'] || '',
                mongodb_passwd: password,
                business_name: '',
                education_or_enterprise: '',
                is_profile: false,
                is_status: true,
                token_usage: 0,
                storage_usage_mb: 0,
                provider: user['_delegate']['providerData'][0]['providerId'],
                created_date: user['_delegate']['metadata']['createdAt'],
                created_time: user['_delegate']['metadata']['creationTime'],
                last_login_date: user['_delegate']['metadata']['lastLoginAt'],
                last_login_time: user['_delegate']['metadata']['lastSignInTime']
            });

            // const formData = new FormData();
            // formData.append('user_token', user['_delegate']['uid'])
            // formData.append('mongodb_passwd', password)
            // await axios2.post('/users/mongodb/create/', formData,{
            //     headers: {
            //         //         //         //         'Content-Type': 'multipart/form-data'
            //     },
            // });

            // const formData2 = new FormData();
            // formData2.append('user_token', user['_delegate']['uid'])
            // formData2.append('project_name', 'Default')
            // formData2.append('description', 'Default Project')
            // formData2.append('mongodb_passwd', password)
            // const response2 = await axios2.post('/projects/', formData2,{
            //     headers: {
            //         //         //         //         'Content-Type': 'multipart/form-data'
            //     },
            // });

            // dispatch({
            //     type: FETCH_PROJECT,
            //     payload: {
            //         projects: response2.data
            //     }
            // });

            navigate('/identity_verification', { replace: true });
        } catch (error) {
            console.error('Error registering user:', error.message);
            throw error;
        }
    };

    const logout = () =>
        firebase
            .auth()
            .signOut()
            .then(() => {
                setSession(null);
                // dispatch({ type: LOGOUT });
                Rdispatch(logoutUser());
                localStorage.clear();
            })
            .catch((err) => console.log(err));

    const resetPassword = async (email) => {
        await firebase.auth().sendPasswordResetEmail(email);
    };

    const updateProfile = () => {};

    // Không block render dựa trên isInitialized từ FirebaseContext
    // Vì App.js đã xử lý initialization với JWT token
    // Comment out để tránh conflict với JWT auth flow
    // if (account.isInitialized !== undefined && !account.isInitialized) {
    //     return <Loader />;
    // }

    const userUpdate = (uid, displayName, email, business_name, phone_number, education_or_enterprise) => {
        const updates = {
            displayName,
            phone_number,
            business_name,
            education_or_enterprise,
            email,
            is_profile: true
        };

        update(ref(db, 'users/' + uid), updates);
        dispatch({
            type: FIREBASE_USER_UPDATE,
            payload: {
                isProfile: true
            }
        });
    };

    const fetchBillings = async () => {
        const formData = new FormData();
        formData.append('user_token', localStorage.getItem('user_token'));
        formData.append('user_type', localStorage.getItem('user_type'));
        const response = await Rdispatch(apiSlice.endpoints.postBillingUsage.initiate(formData)).unwrap();
        dispatch({
            type: FETCH_BILLING,
            payload: { billings: response }
        });
    };

    return (
        <FirebaseContext.Provider
            value={{
                ...state,
                firebaseRegister,
                firebaseEmailPasswordSignIn,
                login: () => {},
                firebaseGoogleSignIn,
                firebaseMicrosoftSignIn,
                firebaseFacebookSignIn,
                logout,
                resetPassword,
                updateProfile,
                userUpdate,
                fetchBillings
            }}
        >
            {children}
        </FirebaseContext.Provider>
    );
};

FirebaseProvider.propTypes = {
    children: PropTypes.node
};

export default FirebaseContext;
